var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_1020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.66665L11.06 3.72665L6.83332 7.95332L7.77332 8.89332L12 4.66665ZM14.8266 3.72665L7.77332 10.78L4.98665 7.99999L4.04665 8.93999L7.77332 12.6667L15.7733 4.66665L14.8266 3.72665ZM0.273315 8.93999L3.99998 12.6667L4.93998 11.7267L1.21998 7.99999L0.273315 8.93999Z",
    fill: "#F32B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_1020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDoubleCheck);
export default __webpack_public_path__ + "static/media/chat_double_check.5ced2e2b65a6e4dbfa5271a87610c4f8.svg";
export { ForwardRef as ReactComponent };